import React from "react";
import { useNavigate } from 'react-router-dom';
import ListVpsUsUserPage from "../ListVpsUsUserPage";

const PageListVpsUsUsing = () => {
    const navigate = useNavigate();

    let redirectChangeUser = (listVps) => {
        navigate('/dich-vu-vps-us/chuyen-khach-hang.html?' + listVps);
    }

    let redirectExportExcel = (listVps) => {
        navigate('/dich-vu-vps-us/xuat-file-excel.html?' + listVps);
    }

    return <ListVpsUsUserPage
        redirectChangeUser={ (listVps) => redirectChangeUser(listVps) }
        redirectExportExcel={ (listVps) => redirectExportExcel(listVps) }
    />

}

export default PageListVpsUsUsing;